<!-- <p>create-rule works!</p> -->
<div *ngIf="!isMobile">
    <app-dialog-header *ngIf="!this.RuleItem" headerText="Create New Rule - {{AssetItem.Name}}"
        (onCloseClick)="onCancelClick()"></app-dialog-header>
    <app-dialog-header *ngIf="this.RuleItem" headerText="Modify Rule - {{RuleItem.RuleDescription}}"
        (onCloseClick)="onCancelClick()"></app-dialog-header>

    <span *ngIf="readonly" class="location-title"
        style="margin-top: 1em; justify-content: center; word-wrap: break-word;">
        This Rule is Read Only - Admins Can Edit rules
    </span>
    <div style="display: grid; grid-template-columns: 1fr 1fr;">
        <div style="padding: 1em; width: 100%; max-width: 800px; max-height: 85vh; overflow-y: auto;" #DialogContainer
            id="DialogContainer">
            <div style="display: flex;">
                <span class="location-title">Rule Details</span>
                <span class="toolbar-spacer"></span>
                <span style="font-style: italic;" *ngIf="RuleItem && RuleItem.CreatedByUserID">Rule Created By:
                    {{RuleItem.CreatedByUserID}}</span>
                <span style="font-style: italic;" *ngIf="RuleItem && RuleItem.CreatedAt">&nbsp;on
                    {{convertEpoch(RuleItem.CreatedAt)}}</span>
            </div>
            <form [formGroup]="dialogForm" autocomplete="off">
                <div class="form-div">
                    <mat-form-field appearance="outline"
                        style="max-width: 100%; margin-top: 0em; padding-bottom: 0px !important;"
                        subscriptSizing="dynamic" class="settings-form-field">
                        <mat-label>Rule Name</mat-label>
                        <input matInput placeholder="Name For This Rule" formControlName="ruleDescription"
                            [readonly]="readonly">
                        <mat-error *ngIf="dialogForm.get('ruleDescription')?.hasError">Rule Name is
                            Required.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="max-width: 100%; padding-bottom: 0px !important;"
                        class="settings-form-field" subscriptSizing="dynamic">
                        <mat-label>Rule Message</mat-label>
                        <input matInput placeholder="Write A Custom Message For This Rule" formControlName="ruleMessage"
                            [readonly]="readonly">
                    </mat-form-field>
                </div>
                <br>
                <span class="location-title">Rule Conditions</span>
                <div class="form-div" style="min-height: 250px;">
                    <div class="form-section">
                        <ejs-dropdownlist [dataSource]='dataPoints' [enablePersistence]="true" placeholder="DataPoint"
                            [popupWidth]="'150%'" [readonly]="readonly" class=" form-box" [fields]="DPfields"
                            style="min-width: 35%; margin: auto" formControlName="dataPoint1"
                            (change)="drawThresholdLine({changingDPValue: $event.value, isFirstValue: true})"
                            (change)="plotDatapoint($event)">
                            <ng-template #itemTemplate let-data>
                                <div class="list-wrapper"
                                    style="display: flex; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                                    <span>{{data.DPTitle}}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                        <ejs-dropdownlist [dataSource]='conditions' [fields]="Confields" [enablePersistence]="true"
                            [popupWidth]="'150%'" [readonly]="readonly" placeholder="Condition" class=" form-box"
                            style="max-width: 25%; margin: auto;" formControlName="condition1"
                            (change)="drawThresholdLine({changingOperatorValue: $event.value, isFirstOperator: true})">
                            <ng-template #itemTemplate let-data>
                                <div class="list-wrapper" style="display: flex; ">
                                    <span>{{data.text}}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                        <div *ngIf="!firstBetween" class="form-box-numeric" style="min-width: 25%; margin: auto;">
                            <ejs-numerictextbox [step]="getStepAmount(1)" formControlName="value1" cssClass="e-custom"
                                placeholder="Limit"
                                (change)="drawThresholdLine({changingLimitValue: $event.value, isFirstLimit: true})">
                            </ejs-numerictextbox>
                        </div>
                        <div *ngIf="firstBetween" class="between-slider" style="min-width: 25%; margin: auto;">
                            <div class="form-box-numeric-double">
                                <div class="form-box-numeric-part alignColumn">
                                    <span>Upper Limit</span>
                                    <ejs-numerictextbox [step]="getStepAmount(1)" formControlName="between1value1"
                                        cssClass="e-custom" placeholder="Upper Limit"
                                        (change)="drawThresholdLine({changingBetween1value1: $event.value})">
                                    </ejs-numerictextbox>
                                </div>
                                <div class="form-box-numeric-part alignColumn">
                                    <ejs-numerictextbox [step]="getStepAmount(1)" formControlName="between1value2"
                                        cssClass="e-custom" placeholder="Lower Limit"
                                        (change)="drawThresholdLine({changingBetween1value2: $event.value})">
                                    </ejs-numerictextbox>
                                    <span>Lower Limit</span>
                                </div>
                            </div>
                            <div class="slider">
                                <!-- [ticks]="getTicks(true)"  -->
                                <ejs-slider id="slider" cssClass="slider_class" step="0.1"
                                    (change)="sliderChange($event, true)"
                                    [value]="[between1SliderBottom, between1SliderTop]" [max]="between1SliderMax"
                                    [ticks]="getTicks(true)" [min]="between1SliderMin" [value]="[0, 100]"
                                    orientation="Vertical" type="Range" [tooltip]="tooltip"></ejs-slider>
                            </div>
                        </div>
                    </div>
                    <div class="form-section" *ngIf="NumberOfDefinitions == 1 && !readonly">
                        <span style="margin: auto; max-width: 30%; cursor: pointer;"
                            class="form-box app-icon app-icon--add" (click)="InsertDefinition()">
                            <span>Add Condition</span>
                            <mat-icon class="condition-icons" />
                        </span>
                    </div>
                    <div *ngIf="NumberOfDefinitions > 1">
                        <div class="form-section">
                            <span class=" form-box" style="max-width: 30%; margin: auto">
                                <ejs-dropdownlist [dataSource]='comparisons' [fields]="Comfields"
                                    [enablePersistence]="true" [readonly]="readonly" placeholder="Comparison"
                                    style="max-width: 80%; margin: auto" formControlName="comparison"
                                    (change)="drawThresholdLine({changingComparisonValue: $event.value})">
                                    <ng-template #itemTemplate let-data>
                                        <div class="list-wrapper" style="display: flex; ">
                                            <span>{{data.text}}</span>
                                        </div>
                                    </ng-template>
                                </ejs-dropdownlist>
                                <mat-icon matTooltip="Remove Condition" (click)="RemoveDefinition()"
                                    class="condition-icons" *ngIf="!readonly" style="cursor: pointer;">clear</mat-icon>
                            </span>
                        </div>
                        <div class="form-section">
                            <ejs-dropdownlist [dataSource]='dataPoints' [enablePersistence]="true"
                                placeholder="DataPoint" [popupWidth]="'150%'" [readonly]="readonly" class=" form-box"
                                [fields]="DPfields" style="min-width: 35%; margin: auto" formControlName="dataPoint2"
                                (change)="drawThresholdLine({changingDPValue: $event.value, isFirstValue: false})"
                                (change)="plotDatapoint($event)">
                                <ng-template #itemTemplate let-data>
                                    <div class="list-wrapper" style="display: flex; ">
                                        <span>{{data.DPTitle}}</span>
                                    </div>
                                </ng-template>
                            </ejs-dropdownlist>
                            <ejs-dropdownlist [dataSource]='conditions' [fields]="Confields" [enablePersistence]="true"
                                [popupWidth]="'150%'" [readonly]="readonly" placeholder="Condition" class=" form-box"
                                style="max-width: 25%; margin: auto" formControlName="condition2"
                                (change)="drawThresholdLine({changingOperatorValue: $event.value, isFirstOperator: false})">
                                <ng-template #itemTemplate let-data>
                                    <div class="list-wrapper" style="display: flex; ">
                                        <span>{{data.text}}</span>
                                    </div>
                                </ng-template>
                            </ejs-dropdownlist>
                            <div *ngIf="!secondBetween" class="form-box-numeric" style="min-width: 25%; margin: auto;">
                                <ejs-numerictextbox [step]="getStepAmount(2)" formControlName="value2"
                                    cssClass="e-custom" placeholder="Limit"
                                    (change)="drawThresholdLine({changingLimitValue: $event.value, isFirstLimit: false})"></ejs-numerictextbox>
                            </div>
                            <div *ngIf="secondBetween" class="between-slider" style="min-width: 25%; margin: auto;">
                                <div class="form-box-numeric-double">
                                    <div class="form-box-numeric-part alignColumn">
                                        <span>Upper Limit</span>
                                        <ejs-numerictextbox [step]="getStepAmount(2)" formControlName="between2value1"
                                            cssClass="e-custom" placeholder="Upper Limit"
                                            (change)="drawThresholdLine({changingBetween2value1: $event.value})">
                                        </ejs-numerictextbox>
                                    </div>
                                    <div class="form-box-numeric-part alignColumn">
                                        <ejs-numerictextbox [step]="getStepAmount(2)" formControlName="between2value2"
                                            cssClass="e-custom" placeholder="Lower Limit"
                                            (change)="drawThresholdLine({changingBetween2value2: $event.value})">
                                        </ejs-numerictextbox>
                                        <span>Lower Limit</span>
                                    </div>
                                </div>
                                <div class="slider">
                                    <ejs-slider [ticks]="getTicks(false)" cssClass="slider_class" step="0.1"
                                        [max]="between2SliderMax" [min]="between2SliderMin"
                                        (change)="sliderChange($event, false)"
                                        [value]="[between2SliderBottom, between2SliderTop]" orientation="Vertical"
                                        type="Range"></ejs-slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <span class="location-title">Rule Settings</span>
                <div class="form-div">
                    <mat-form-field appearance="outline" style="max-width: 25%; padding-bottom: 0px !important;"
                        class="settings-form-field" subscriptSizing="dynamic">
                        <mat-label>Trigger Time</mat-label>
                        <input matInput formControlName="ruleTime" placeholder="HH:MM" [readonly]="readonly"
                            (keyup)="drawThresholdLine()" />
                        <mat-error
                            *ngIf="dialogForm.get('ruleTime')?.hasError('timeFormat') && dialogForm.get('ruleTime')?.touched">
                            Please enter a valid time in HH:MM format.
                        </mat-error>
                    </mat-form-field>
                    <span style="max-width: 25%; padding-bottom: 0px !important;">
                        <mat-slide-toggle formControlName="ruleEnabled" class="form-slide-toggle" color="Primary">Rule
                            Enabled</mat-slide-toggle>
                        <mat-slide-toggle formControlName="CMMSEnabled" class="form-slide-toggle" color="Primary"
                            *ngIf="checkFeature(AccountFeatures.SAP)">CMMS
                            Enabled</mat-slide-toggle>
                    </span>
                </div>
                <div mat-dialog-actions>
                    <button mat-button [mat-dialog-close]="dialogForm.value"
                        [disabled]="dialogForm.invalid || !dialogForm.dirty || readonly ">Ok</button>
                    <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
                </div>
            </form>
        </div>
        <div class="form-div alignRow alignColumn" style="padding-top: 0px; padding-bottom: 0px;">
            <div class="local-spinner" *ngIf="spinner">
                <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                    [attr.x-contenttype]="'image/gif'" alt="Loading..." />
            </div>

            <div class="alignColumn">
                <div class="noshrink alignRow ">
                    <span *ngIf="visibleStartDate && visibleEndDate" class="hideoverflow"
                        style="font-weight: bolder; font-size: larger;">({{getShortDate(visibleStartDate)}}
                        - {{getShortDate(visibleEndDate)}})</span>
                    <mat-icon matTooltip="Navigate Backwards"
                        (click)="navigateByDuration(false)">chevron_left</mat-icon>

                    <app-duration-selector [(duration)]="strDuration"
                        (durationChange)="selectTime($event)"></app-duration-selector>

                    <mat-icon matTooltip="Navigate Forwards" (click)="navigateByDuration(true)">chevron_right</mat-icon>

                    <span mat-icon-button [matMenuTriggerFor]="timeMenu" style="margin-left: 10px;" class="alignRow"
                        matTooltip="Date Range" #timeTrigger="matMenuTrigger">
                        <mat-icon>access_time</mat-icon>
                    </span>

                    <mat-menu #timeMenu="matMenu">
                        <div style="margin: 1em;">
                            <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                                [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                        </div>
                    </mat-menu>
                </div>

                <ejs-chart #myChart id="myChart" [primaryXAxis]='sensorXAxis' [zoomSettings]="zoomSettings"
                    [legendSettings]='legend' [tooltip]='tooltipSettings' [crosshair]='crosshair' background="#FFFFFF"
                    [border]="borderSettings" [selectionMode]=' selectionMode' [palettes]='palette'
                    [height]="chartHeight" [width]="chartWidth" (zoomComplete)="onZoom($event)"
                    (scrollChanged)="onScroll($event)" (tooltipRender)="onTooltipRender($event)">
                </ejs-chart>

                <span>{{getStriplineMessage()}}</span>

                <div style="width: 100%; height: 250px; overflow-y: auto; border-top: 1px solid gray; padding-top: 0.2em;"
                    *ngIf="ruleEdits && ruleEdits.length > 0">
                    <div style="display: flex;">
                        <span class="location-title">Edit History</span>
                        <span class="toolbar-spacer"></span>
                    </div>
                    <div class="edit-history">
                        <span>Previous Conditions</span>
                        <span>New Conditions</span>
                        <span>User</span>
                        <span>Timestamp</span>
                    </div>
                    <ejs-listview #listviewInstance [dataSource]='ruleEdits' cssClass='e-list-template'>
                        <ng-template #template let-dataSource>
                            <div class="alignRow alignColumn" style="font-weight: bold;"
                                *ngIf="dataSource.PreviousEnabled != dataSource.NewEnabled">
                                <span *ngIf="dataSource.PreviousEnabled == true && dataSource.NewEnabled == false"
                                    style="color: lightsalmon;">
                                    Rule Disabled
                                </span>
                                <span *ngIf="dataSource.PreviousEnabled == false && dataSource.NewEnabled == true"
                                    style="color: lightgreen;">
                                    Rule Enabled
                                </span>
                            </div>

                            <div class="alignRow alignColumn" style="font-weight: bold;"
                                *ngIf="dataSource.PreviousCMMSEnabled != dataSource.NewCMMSEnabled">
                                <span
                                    *ngIf="dataSource.PreviousCMMSEnabled == true && dataSource.NewCMMSEnabled == false"
                                    style="color: lightsalmon;">
                                    CMMS Disabled
                                </span>
                                <span
                                    *ngIf="dataSource.PreviousCMMSEnabled == false && dataSource.NewCMMSEnabled == true"
                                    style="color: lightgreen;">
                                    CMMS Enabled
                                </span>
                            </div>

                            <div class="ejs-listview-item edit-history">
                                <span>{{ dataSource.PreviousConditions }}</span>
                                <span>{{ dataSource.NewConditions }}</span>
                                <span>{{ dataSource.UserID}}</span>
                                <span>{{ convertEpoch(dataSource.Timestamp) }}</span>
                            </div>
                        </ng-template>
                    </ejs-listview>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isMobile">
    <app-dialog-header *ngIf="!this.RuleItem" headerText="Create New Rule - {{AssetItem.Name}}"
        (onCloseClick)="onCancelClick()"></app-dialog-header>
    <app-dialog-header *ngIf="this.RuleItem" headerText="Modify Rule - {{RuleItem.RuleDescription}}"
        (onCloseClick)="onCancelClick()"></app-dialog-header>

    <div *ngIf="readonly" class="location-title"
        style="margin-top: 1em; justify-content: center; word-wrap: break-word;">
        This Rule is Read Only - Admins Can Edit rules
    </div>
    <div style="padding: 1em; width: 100%; max-width: 800px; max-height: 85vh; overflow-y: auto;" #DialogContainer
        id="DialogContainer">
        <div class="form-div">
            <div class="local-spinner" *ngIf="spinner">
                <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                    [attr.x-contenttype]="'image/gif'" alt="Loading..." />
            </div>

            <div class="alignColumn">
                <ejs-chart #myChart [primaryXAxis]='sensorXAxis' [zoomSettings]="zoomSettings" [legendSettings]='legend'
                    [tooltip]='tooltipSettings' [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings"
                    [selectionMode]=' selectionMode' [palettes]='palette' height="350px" width="700px">
                </ejs-chart>
                <div class="noshrink alignRow alignColumn">
                    <app-duration-selector [(duration)]="strDuration"
                        (durationChange)="selectTime($event)"></app-duration-selector>
                </div>
            </div>

        </div>
        <span class="location-title">Rule Conditions</span>
        <form [formGroup]="dialogForm" autocomplete="off">
            <div class="form-div">
                <div class="form-section">
                    <ejs-dropdownlist [dataSource]='dataPoints' [enablePersistence]="true" placeholder="DataPoint"
                        [popupWidth]="'150%'" [readonly]="readonly" class=" form-box" [fields]="DPfields"
                        style="min-width: 40%; margin: auto" formControlName="dataPoint1"
                        (change)="drawThresholdLine({changingLimitValue: $event.value, isFirstLimit: true})">
                        <ng-template #itemTemplate let-data>
                            <div class="list-wrapper"
                                style="display: flex; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                                <span>{{data.DPTitle}}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                    <ejs-dropdownlist [dataSource]='conditions' [fields]="Confields" [enablePersistence]="true"
                        [readonly]="readonly" placeholder="Condition" class=" form-box"
                        style="max-width: 35%; margin: auto;" formControlName="condition1"
                        (change)="drawThresholdLine()">
                        <ng-template #itemTemplate let-data>
                            <div class="list-wrapper" style="display: flex; ">
                                <span>{{data.text}}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                    <mat-form-field appearance="outline" style="max-width: 15%; padding-bottom: 0px !important;"
                        class="creation-form-field" subscriptSizing="dynamic">
                        <mat-label>Limit</mat-label>
                        <input matInput placeholder="" formControlName="value1" [readonly]="readonly"
                            (keyup)="drawThresholdLine()">
                    </mat-form-field>
                </div>
                <div class="form-section" *ngIf="NumberOfDefinitions == 1 && !readonly">
                    <span style="margin: auto; max-width: 30%; cursor: pointer;" class="form-box app-icon app-icon--add"
                        (click)="InsertDefinition()">
                        <span>Add Condition</span>
                        <mat-icon class="condition-icons" />
                    </span>
                </div>
                <div *ngIf="NumberOfDefinitions > 1">
                    <div class="form-section">
                        <span class=" form-box" style="max-width: 30%; margin: auto">
                            <ejs-dropdownlist [dataSource]='comparisons' [fields]="Comfields" [enablePersistence]="true"
                                [readonly]="readonly" placeholder="Comparison" style="max-width: 80%; margin: auto"
                                formControlName="comparison">
                                <ng-template #itemTemplate let-data>
                                    <div class="list-wrapper" style="display: flex; ">
                                        <span>{{data.text}}</span>
                                    </div>
                                </ng-template>
                            </ejs-dropdownlist>
                            <mat-icon matTooltip="Remove Condition" (click)="RemoveDefinition()" class="condition-icons"
                                *ngIf="!readonly" style="cursor: pointer;">clear</mat-icon>
                        </span>
                    </div>
                    <div class="form-section">
                        <ejs-dropdownlist [dataSource]='dataPoints' [enablePersistence]="true" placeholder="DataPoint"
                            [popupWidth]="'150%'" [readonly]="readonly" class=" form-box" [fields]="DPfields"
                            style="min-width: 40%; margin: auto" formControlName="dataPoint2"
                            (change)="drawThresholdLine({changingLimitValue: $event.value, isFirstLimit: false})">
                            <ng-template #itemTemplate let-data>
                                <div class="list-wrapper" style="display: flex; ">
                                    <span>{{data.DPTitle}}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                        <ejs-dropdownlist [dataSource]='conditions' [fields]="Confields" [enablePersistence]="true"
                            [readonly]="readonly" placeholder="Condition" class=" form-box"
                            style="max-width: 35%; margin: auto" formControlName="condition2"
                            (change)="drawThresholdLine()">
                            <ng-template #itemTemplate let-data>
                                <div class="list-wrapper" style="display: flex; ">
                                    <span>{{data.text}}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                        <mat-form-field appearance="outline" style="max-width: 15%; padding-bottom: 0px !important;"
                            class="creation-form-field" subscriptSizing="dynamic">
                            <mat-label>Limit</mat-label>
                            <input matInput placeholder="" formControlName="value2" [readonly]="readonly"
                                (keyup)="drawThresholdLine()">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <br>
            <span class="location-title">Rule Settings</span>
            <div class="form-div">
                <mat-form-field appearance="outline"
                    style="max-width: 100%; margin-top: 0em; padding-bottom: 0px !important;" subscriptSizing="dynamic"
                    class="settings-form-field">
                    <mat-label>Rule Name</mat-label>
                    <input matInput placeholder="Description For This Rule" formControlName="ruleDescription"
                        [readonly]="readonly">
                    <mat-error *ngIf="dialogForm.get('ruleDescription')?.hasError">
                        Rule Name is Required.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" style="max-width: 100%; padding-bottom: 0px !important;"
                    class="settings-form-field" subscriptSizing="dynamic">
                    <mat-label>Rule Message</mat-label>
                    <input matInput placeholder="Write A Custom Message For This Rule" formControlName="ruleMessage"
                        [readonly]="readonly">
                </mat-form-field>
                <mat-form-field appearance="outline" style="max-width: 50%; padding-bottom: 0px !important;"
                    class="settings-form-field" subscriptSizing="dynamic">
                    <mat-label>Trigger Time</mat-label>
                    <input matInput formControlName="ruleTime" placeholder="HH:MM" [readonly]="readonly"
                        (keyup)="drawThresholdLine()" />
                    <mat-error
                        *ngIf="dialogForm.get('ruleTime')?.hasError('timeFormat') && dialogForm.get('ruleTime')?.touched">
                        Please enter a valid time in HH:MM format.
                    </mat-error>
                </mat-form-field>
                <mat-slide-toggle formControlName="ruleEnabled" class="form-slide-toggle" color="Primary">Rule
                    Enabled</mat-slide-toggle>
                <mat-slide-toggle formControlName="CMMSEnabled" class="form-slide-toggle" color="Primary"
                    *ngIf="checkFeature(AccountFeatures.SAP)">CMMS
                    Enabled</mat-slide-toggle>
            </div>
            <div mat-dialog-actions>
                <button mat-button [mat-dialog-close]="dialogForm.value"
                    [disabled]="dialogForm.invalid || !dialogForm.dirty || readonly ">Ok</button>
                <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
            </div>
        </form>
    </div>
</div>